'use strict';

/**
 * @param {Vue} Vue
 * @param {Object} options
 * @return {undefined}
 */
export default (Vue: any, options: any = {}) => {
    const sizeRatios = options.sizeRatios || [
        {
            id: 'xs',
            minWidth: 0
        },
        {
            id: 'sm',
            minWidth: 600
        },
        {
            id: 'md',
            minWidth: 960
        },
        {
            id: 'lg',
            minWidth: 1080
        }
    ];

    Vue.prototype.$appSize = function () {
        const elementWidth = this.$el.offsetWidth;

        return sizeRatios.reduce((matched: any, ratio: any) => !matched || ratio.minWidth < elementWidth ? ratio.id : matched, undefined);
    };
};
